import { createApi } from "@reduxjs/toolkit/query/react";
import { getBaseQuery } from "../baseQuery";
import { conversationService } from "../conversation";

export interface CreateThreadDTO {
  parentConversationId: string;
  parentMessageId: string;
  toolCallId: string;
}

export interface CreateThreadResponse {
  threadId: string;
}

export interface ApplyChangesDTO {
  threadId: string;
  parentConversationId: string;
  parentMessageId: string;
  toolCallId: string;
}

export interface ApplyChangesResponse {
  success: boolean;
}

export interface DeleteThreadResponse {
  success: boolean;
}

export const threadService = createApi({
  reducerPath: "threadService",
  baseQuery: getBaseQuery("zeus"),
  endpoints: (builder) => ({
    createThread: builder.mutation<CreateThreadResponse, CreateThreadDTO>({
      query: ({ parentConversationId, ...body }) => ({
        url: `/api/conversations/${parentConversationId}/threads`,
        method: "POST",
        body,
      }),
    }),

    applyThreadChanges: builder.mutation<ApplyChangesResponse, ApplyChangesDTO>({
      query: ({ threadId, parentConversationId, ...body }) => ({
        url: `/api/conversations/${parentConversationId}/threads/${threadId}/apply`,
        method: "POST",
        body,
      }),
      async onQueryStarted({ parentConversationId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate the parent conversation's messages to trigger a refetch
          dispatch(
            conversationService.util.invalidateTags([
              { type: "Messages", id: parentConversationId },
            ]),
          );
        } catch {
          // If apply fails, don't invalidate
        }
      },
    }),

    deleteThread: builder.mutation<
      DeleteThreadResponse,
      { threadId: string; conversationId: string }
    >({
      query: ({ threadId, conversationId }) => ({
        url: `/api/conversations/${conversationId}/threads/${threadId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useCreateThreadMutation,
  useApplyThreadChangesMutation,
  useDeleteThreadMutation,
} = threadService;
